import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import { isArray } from '@/utils/helper';
import CameraIcon from '../icons/CameraIcon';
import CaretDownIcon from '../icons/CaretDownIcon';
import Paragraph, { VARIANT } from '../Paragraph';
interface Props {
  tags?: number[];
}
const PhotoSearch = ({
  tags
}: Props) => {
  const {
    t
  } = useTranslation('askQuestion');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const takePictureEvent = () => {
    trackCustomEvent(CustomEventTypes.INITIATE_DISEASE_COMMUNICATION, isArray(tags) ? JSON.stringify(tags) : undefined);
  };
  return <Link className="flex justify-between items-center gap-3 bg-primary-20 px-4 py-4.5 rounded-lg w-full h-full text-left" href="/ask-question" onClick={takePictureEvent} data-testid="photo-search-button" data-sentry-element="Link" data-sentry-component="PhotoSearch" data-sentry-source-file="PhotoSearch.tsx">
      <div className="bg-white p-2 rounded-full w-12 h-12 grow-0 shrink-0">
        <CameraIcon className="fill-primary-100" data-sentry-element="CameraIcon" data-sentry-source-file="PhotoSearch.tsx" />
      </div>
      <Paragraph className="grow" isHighlighted variant={VARIANT.BIG} data-sentry-element="Paragraph" data-sentry-source-file="PhotoSearch.tsx">
        {t('take_pic_get_soln')}
      </Paragraph>
      <CaretDownIcon className="fill-transparent stroke-2 stroke-primary-100 w-6 h-6 -rotate-90 grow-0 shrink-0" data-sentry-element="CaretDownIcon" data-sentry-source-file="PhotoSearch.tsx" />
    </Link>;
};
export default PhotoSearch;